module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/zl/gift/level3.png";